import { render, staticRenderFns } from "./carbon.vue?vue&type=template&id=105cb5a6&"
import script from "./carbon.vue?vue&type=script&lang=js&"
export * from "./carbon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports